export const ru = {
    'client-features': 'Фичи клиента',
    'operator-features': 'Фичи оператора'
};
